
import React, { useEffect, useState } from 'react';
import ReactJWPlayer from 'react-jw-player';

import ExternalConfiguration from '../../external-configuration';

import Analytics from '../../controllers/Analytics/Base';

import './Wrapper-custom-3-player.css';

const LogFileString = 'components::Wrapper-custom-3-player::Wrapper-custom-3-player';

const Constants = {
  PlayerId: 'custom-3-player',
  PlayerScritp: `${ExternalConfiguration.SelfHostedExternalSrcPaths.custom_3_player}/jwplayer.js`,
  PlayerEvents: {
    play: 'play',
    time: 'time',
    pause: 'pause',
    buffer: 'buffer',
    error: 'error',
    adImpresion: 'adImpresion',
    adSkipped: 'adSkipped',
    adClick: 'adClick',
    adError: 'adError',
    adBreakEnd: 'adBreakEnd',
    adComplete: 'adComplete',
    levels: 'levels',
    playlist: 'playlist',
    playlistItem: 'playlistItem',
  },
};

const Globals = {
  player: null,
};

const update_analytics_quality_data = (player, analyticsConfiguration) => {
  const LogFunctionString = `${LogFileString}::update_analytics_quality_data`;
  if( analyticsConfiguration) {
    if( !analyticsConfiguration.custom_3_player_aux_data) analyticsConfiguration.custom_3_player_aux_data = {};
    const { custom_3_player_aux_data } = analyticsConfiguration;
    custom_3_player_aux_data.currentQuality = player.getCurrentQuality();
    custom_3_player_aux_data.visualQuality = player.getVisualQuality();
    try {
      analyticsConfiguration.bitrate = custom_3_player_aux_data.visualQuality?.level?.bitrate ??
          custom_3_player_aux_data.qualityLevels?.[ custom_3_player_aux_data.currentQuality ]?.bitrate ;
    } catch( error) {
      console.warn( new Date(), `WARNING ${LogFunctionString} - error: ${error}`);
    }
  }
};

const registerAnalyticsAutomapEvents = (player, analyticsConfiguration) => {
  const { PlayerEvents } = Constants;
  const AnalyticsAutomapEvents = {
    [PlayerEvents.play]: Analytics.onPlay,
    // [PlayerEvents.time]: Analytics.onTime,
    [PlayerEvents.pause]: Analytics.onPause,
    // [PlayerEvents.buffer]: Analytics.onBuffer,
    [PlayerEvents.error]: Analytics.onError,
    [PlayerEvents.adImpresion]: Analytics.onAdImpresion,
    [PlayerEvents.adSkipped]: Analytics.onAdSkipped,
    [PlayerEvents.adClick]: Analytics.onAdClicked,
    [PlayerEvents.adError]: Analytics.onAdError,
    [PlayerEvents.adBreakEnd]: Analytics.onAdPlayed,   // NOTE tenia esto puesto pero ahora no lo encuentro en la documentacion, ??, duplicado a adComplete
    [PlayerEvents.adComplete]: Analytics.onAdPlayed,
  };

  Object.keys( AnalyticsAutomapEvents).forEach( eventKey => {
    player.on( eventKey, event => {
      update_analytics_quality_data( player, analyticsConfiguration);
      if( analyticsConfiguration) AnalyticsAutomapEvents[eventKey]( analyticsConfiguration);
    });
  });
};

// DOC https://docs.jwplayer.com/players/docs/jw8-reference
// https://docs.jwplayer.com/players/reference/playback
const registerPlayerEvents = (player, props) => {
  const { PlayerEvents } = Constants;
  const { onTime, analyticsConfiguration } = props;

  registerAnalyticsAutomapEvents( player, analyticsConfiguration);

  player.on( PlayerEvents.time, event => {
    if( onTime) onTime( event);
    update_analytics_quality_data( player, analyticsConfiguration);
    if( analyticsConfiguration) Analytics.onTime( analyticsConfiguration, event.position, player.getDuration());
  });

  player.on( PlayerEvents.buffer, event => {
    update_analytics_quality_data( player, analyticsConfiguration);
    if( analyticsConfiguration) {
      // DOC https://docs.jwplayer.com/players/reference/playback-events#onbuffer
      // const BufferEventStates = {
      //   buffering: 'buffering',
      //   idle: 'idle',
      //   playing: 'playing',
      //   paused: 'paused',
      //   stalled: 'stalled',
      // };
      const BufferEventReasons = {
        paused: 'paused',
        loading: 'loading',
        complete: 'complete',
        stalled: 'stalled',
        error: 'error',
      };
      if( event.reason === BufferEventReasons.stalled) {
        Analytics.onBuffer( analyticsConfiguration);
      }
    }
  });
};

const onReady = ( event, props ) => { // REVIEW TODO mover la definicion de todos estos eventos a un archivo separado
  const { PlayerId, PlayerEvents } = Constants;
  const { onPlayer, analyticsConfiguration } = props;

  const player = Globals.player = window.jwplayer( PlayerId);
  if( onPlayer) onPlayer( player);

  if( props.custom_3_playerConfiguration?.auxiliarData?.download) {
    player.addButton(
      ExternalConfiguration.DefaultDownloadButtonImage,
      'Download Video',
      () => { window.location.href = player.getPlaylistItem().progressive },
      'download',
    );
  }

  if( analyticsConfiguration) {
    player.on( PlayerEvents.levels, event => {
      if( !analyticsConfiguration.custom_3_player_aux_data) analyticsConfiguration.custom_3_player_aux_data = {};
      const { custom_3_player_aux_data } = analyticsConfiguration;
      // custom_3_player_aux_data.qualityLevels = player.getQualityLevels();
      custom_3_player_aux_data.qualityLevels = event.levels;
    });
  }

  // REVIEW NOTE este se dispara cuando cambia la playlist completa, // DOC https://docs.jwplayer.com/players/reference/playlist-events
  // player.on( PlayerEvents.playlist, event => {
  // });

  player.on( PlayerEvents.playlistItem, event => {
    Analytics.changeCurrentMedia( analyticsConfiguration, props.contentData, event.index, player.getDuration());
  });

  registerPlayerEvents( player, props);
};

export default function Wrapper_custom_3_player( props) {
  const { width, height } = props.custom_3_playerConfiguration?.customProps ?? {};
  const { PlayerId, PlayerScritp } = Constants;
  const { player } = Globals;

  if( player && (player.getWidth() !== width || player.getHeight() !== height)) player.resize( width, height);

  // console.log( 'components::Wrapper-custom-3-player::render - props: ', props);    // DEVELOP
  return (
    <div className='wrapper-custom-3-player-container'>
      <ReactJWPlayer
        playerId={ PlayerId }
        playerScript={ PlayerScritp }
        playlist={ props.custom_3_playerConfiguration.playlist }
        customProps={ props.custom_3_playerConfiguration.customProps }
        licenseKey={ ExternalConfiguration.Credentials.Custom_3_playerLicenseKey }
        onReady={ event => onReady( event, props) }
        key={ props.custom_3_playerConfiguration.key }
      />
    </div>
  );
}
